import { useEffect, useState } from "react";
import "./Header.css"
import { List, Search, CaretDownFill, Gear, MoonStarsFill, SunFill } from 'react-bootstrap-icons';
import { useSelector, useDispatch } from "react-redux";
import {Link} from "react-router-dom"
import { usersActions } from "../../data/user";
import OutsideClickHandler from "react-outside-click-handler";
import useT from "../../i18n/useT";
import NotificationBell from "../../components/NotificationBell/NotificationBell";

const Header = ({minimizer, minimized, onToggle}) => {
    const user = useSelector((state) => state.user);
    const lang = user.language;
    const theme = user.theme;
    const dispatch = useDispatch();
    const t = useT();
    const changeLanguage = (l) => { dispatch(usersActions.setLanguage(l)); setShowLanguage(false); };
    const [vinCode, setVinCode] = useState("");
    const [activeFlag, setActiveFlag] = useState("");
    const [showLanguage, setShowLanguage] = useState(false);
    const handlers = {
        searchByVin(){

        }
    }

    useEffect(() => {
        if(lang === "geo") setActiveFlag("https://upload.wikimedia.org/wikipedia/commons/0/0f/Flag_of_Georgia.svg");
        if(lang === "en") setActiveFlag("https://upload.wikimedia.org/wikipedia/commons/d/de/Flag_of_the_United_States_%281837%E2%80%931845%29.svg");
        if(lang === "ru") setActiveFlag("https://upload.wikimedia.org/wikipedia/en/thumb/f/f3/Flag_of_Russia.svg/960px-Flag_of_Russia.svg.png");
    }, [lang])

    return(
        <header className="header-container">
            <div className="header-section">
                <List onClick={() => (onToggle ? onToggle() : minimizer(!minimized))} style={{fontSize: "30px", cursor: "pointer", fontWeight: "bold"}} />
                <div className="header-search-by-vin">
                    <input onChange={(e) => setVinCode(e.target.value)} value={vinCode} placeholder={t("header.searchByVin")} type="text" className="form-control"/>
                    <button onClick={handlers.searchByVin}><Search /></button>
                </div>
            </div>
            <div className="header-section">
                <div className="dropdown-section">
                    <div className="dropdown-button language-button" onClick={() => setShowLanguage((s) => !s)} style={{cursor: "pointer"}}>
                        <div style={{backgroundImage: `url('${activeFlag}')`}} className="selected-language-flag"></div>
                        <span>{lang === "geo" && "ქართ"}{lang === "en" && "Eng"}{lang === "ru" && "Рус"}</span>
                        <CaretDownFill style={{color: "white"}}/>
                    </div>
                    {showLanguage && <OutsideClickHandler onOutsideClick={() => setShowLanguage(false)}>
                        <div className="dropdown-content">
                            <div className="dropdown-content-item" onClick={() => changeLanguage("geo")}><div style={{backgroundImage: `url('https://upload.wikimedia.org/wikipedia/commons/0/0f/Flag_of_Georgia.svg')`}}></div><span>ქართული</span></div>
                            <div className="dropdown-content-item" onClick={() => changeLanguage("en")}><div style={{backgroundImage: `url('https://upload.wikimedia.org/wikipedia/commons/d/de/Flag_of_the_United_States_%281837%E2%80%931845%29.svg')`}}></div><span>English</span></div>
                            <div className="dropdown-content-item" onClick={() => changeLanguage("ru")}><div style={{backgroundImage: `url('https://upload.wikimedia.org/wikipedia/en/thumb/f/f3/Flag_of_Russia.svg/960px-Flag_of_Russia.svg.png')`}}></div><span>Русский</span></div>
                        </div>
                    </OutsideClickHandler>}
                </div>
                <button
                    className="theme-toggle"
                    title={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
                    onClick={() => dispatch(usersActions.setTheme(theme === "dark" ? "light" : "dark"))}
                >
                    {theme === "dark" ? <SunFill /> : <MoonStarsFill />}
                </button>
                <div style={{display: "flex", alignItems: "center", marginLeft: "12px"}}><NotificationBell /></div>
                <Link to="/account-settings" style={{display: "flex", alignItems: "center"}}><Gear style={{fontSize: "20px", marginLeft: "15px"}} /></Link>
                <div className="user-account-container">
                    <div className="logged-in-user-initials">{user.name.slice(0,1).toUpperCase()}{user.surname.slice(0,1).toUpperCase()}</div>
                    <div className="logged-in-user-info">
                        <span className="logged-in-user-username" title={user.username}>{user.username.slice(0,13)}{user.username.length > 13 && "..."}</span>
                        <span className="logged-in-user-email" title={user.email}>{user.email.slice(0,13)}{user.email.length > 13 && "..."}</span>
                    </div>
                </div>
            </div>
        </header>
    )
}

export default Header